"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfAccessor = void 0;
class SelfAccessor {
    constructor(client) {
        this.client = client;
    }
    async get() {
        return this.client.get('self');
    }
}
exports.SelfAccessor = SelfAccessor;
//# sourceMappingURL=accessors.js.map